/**
 * <StudentOnBoarding />
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
//
import './onBoarding.scss';
import arrowImg from './images/arrow@2x.png';

class StudentOnBoarding extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    showArrow: PropTypes.bool,
  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }

  render() {
    const {
      title,
      text,
      image,
      showArrow,
    } = this.props;

    return (
      <div className='on-boarding'>
        {this.props.children}
        <div className='on-boarding-text'>
          <h2>{title}</h2>
          <p>{text}</p>
        </div>
        <img src={image} />
        { showArrow && <img className='arrow-img' src={arrowImg}/> }
      </div>
    )
  }
}

export default StudentOnBoarding;



// WEBPACK FOOTER //
// ./src/template/OnBoardingNatural/index.js